import { useAccountInfo } from '@vs/hooks/hook-account-info';
import { useAvatarUrl } from '@vs/hooks/hook-use-avatar-url';
import { PortalAvatarUserProfileCard } from '@vs/ui/portal/avatar-user-profile-card';
import { Env } from '@vs/utils/envConfig';
import { useTranslation } from 'react-i18next';

export type PropsAccountInfoCard = {
  env: Env;
};

export default function AccountInfoCard({ env }: PropsAccountInfoCard) {
  const { data: accountInfo } = useAccountInfo();
  const accountAvatarUrl = useAvatarUrl({
    size: { width: 150, height: 150 },
    assetsOrigin: env.assets.vs,
  });
  const { t } = useTranslation('shared');
  const userName =
    `${accountInfo?.given_name ?? ''} ${accountInfo?.family_name ?? ''}`.trim();

  return (
    <PortalAvatarUserProfileCard
      testIdName="account-info"
      title={t('avatar_menu.account')}
      textMain={userName}
      textSub={accountInfo?.email}
      logoUrl={accountAvatarUrl}
      link={{
        href: env.appUrl.accountPortal,
        label: t('avatar_menu.label.manage_account'),
      }}
    />
  );
}
